module.exports = __webpack_public_path__ + "assets/img/logo-en.53b4f56a.png";